"use strict";
import angular from "angular";

import auth from "./auth";
import notify from "./notify";
import api from "./api";
import common from "./common";
import paperwork from "./paperwork";
import publicWafla from "./wafla";
import communication from "./communication";
let module = angular.module("app.common", [
    auth.name,
    notify.name,
    api.name,
    common.name,
    paperwork.name,
    publicWafla.name,
    communication.name,
]);

export default module;
